import type { HighlightInfo, StandardForm } from '@/service'
import { pick } from 'xe-utils'

class Rangy {
  private HIGHLIGHT_LINK = 'highlight-link'
  createSurroundSpan(customProp: Record<string, string>, classnames?: string) {
    const span = document.createElement('span')
    classnames && span.classList.add(classnames)
    for (let [key, value] of Object.entries(customProp)) {
      span.setAttribute(`data-${key}`, value)
    }
    return span
  }
  /**
   * @description 判断传入的 html 字符串是否含有 HIGHLIGHT_LINK
   */
  hasHighlightLink(html: string) {
    const div = document.createElement('div')
    div.innerHTML = html
    return div.querySelector(`.${this.HIGHLIGHT_LINK}`)
  }
  /**
   * @description 判断传入的元素是否是 HIGHLIGHT_LINK span
   */
  isHighlightSapn(el: Element | EventTarget | null): el is HTMLElement {
    return (
      el instanceof Element &&
      el.tagName === 'SPAN' &&
      el.classList.contains(this.HIGHLIGHT_LINK)
    )
  }

  /**
   * @description 传入span元素，解析它上面的自定义属性
   */
  parseSurroundSpan(span: HTMLElement) {
    while (span) {
      if (span.classList.contains(this.HIGHLIGHT_LINK)) break
      if (span.tagName !== 'SPAN') return null
      span = span.parentElement!
    }
    const attributes = span.attributes
    const customAttributes: Record<string, string> = {}

    for (let i = 0; i < attributes.length; i++) {
      const attribute = attributes[i]
      if (attribute.name.startsWith('data-')) {
        const key = attribute.name
          .slice(5)
          .replace(/-./g, (x) => x[1].toUpperCase())
        customAttributes[key] = attribute.value
      }
    }

    return customAttributes
  }

  getTextNode(el: HTMLElement, arr: Text[] = []) {
    for (let node of Array.from(el.childNodes)) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        // 元素节点
        this.getTextNode(node as HTMLElement, arr)
      } else if (node.nodeType === Node.TEXT_NODE) {
        // 文本节点
        arr.push(node as Text)
      }
    }
    return arr
  }

  surroundSpan(dom: HTMLDivElement, text: string, newParent: HTMLElement) {
    let content = dom.innerText
    let startOffset = content.indexOf(text)
    if (startOffset === -1) return dom
    let endOffset = startOffset + text.length
    let textNodes = this.getTextNode(dom)

    let count = 0
    let hasStart = false
    for (let i = 0; i < textNodes.length; i++) {
      let node = textNodes[i]
      let range = document.createRange()
      if (count <= startOffset && count + node.length > startOffset) {
        // 开始节点
        range.setStart(node, startOffset - count)
        hasStart = true
        if (count + node.length >= endOffset) {
          // 结束节点也是同一个node
          range.setEnd(node, endOffset - count)
          range.surroundContents(newParent)
          return dom
        }
      } else if (count < endOffset && count + node.length >= endOffset) {
        // 结束节点
        range.setStart(node, 0)
        range.setEnd(node, endOffset - count)
        range.surroundContents(newParent)
        return dom
      } else if (hasStart) {
        // 开始和结束间的节点
        range.selectNode(node)
        range.surroundContents(newParent)
      }
      count += node.length
    }
    console.error('没找到结束的位置')
    return dom
  }

  /**
   * 将传入的原始文本添加上高亮信息后返回
   * @param content 原始文本
   * @param highlightArr 对话内容高亮信息
   * @param ratingInfo 评分表高亮信息
   */
  addHighlightInfo(
    content: string,
    highlightInfo: HighlightInfo = {
      check_error: [],
      check_miss: [],
      check_success: []
    },
    ratingInfo: StandardForm[] = []
  ) {
    let ctn = document.createElement('div')
    // 如果用innerText, \n 会被转为 <br />
    ctn.innerHTML = content
    let arr = highlightInfo.check_error.slice().concat(highlightInfo.check_miss)
    for (let item of arr) {
      if (!item.report) continue
      this.surroundSpan(
        ctn,
        item.report,
        this.createSurroundSpan(
          pick(item, ['report_id', 'reason', 'originText']),
          this.HIGHLIGHT_LINK
        )
      )
    }
    console.log(ctn.innerHTML)
    for (let item of ratingInfo) {
      if (!item.rep_text) continue
      this.surroundSpan(
        ctn,
        item.rep_text,
        this.createSurroundSpan(pick(item, ['std_id']))
      )
    }
    console.log(ctn.innerHTML)
    return ctn.innerHTML
  }

  getInnerText(html: string) {
    let dom = document.createElement('div')
    dom.innerHTML = html
    return dom.innerText
  }
}

export default Rangy
